/* eslint-disable no-shadow */

export enum NFSeTypeEnum {
  NFS_E = "NFS-e",
  NFS_E_NACIONAL = "NFS-e | Nacional",
}

export const NFSeTypeLabels = {
  [NFSeTypeEnum.NFS_E]: "NFS-e",
  [NFSeTypeEnum.NFS_E_NACIONAL]: "NFS-e | Nacional",
};

export const NFSeTypeList = [
  { label: NFSeTypeLabels[NFSeTypeEnum.NFS_E], value: NFSeTypeEnum.NFS_E },
  { label: NFSeTypeLabels[NFSeTypeEnum.NFS_E_NACIONAL], value: NFSeTypeEnum.NFS_E_NACIONAL },
];